import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import SendIcon from '@material-ui/icons/Send';
import Alert from '@material-ui/lab/Alert';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { reSubmitTask } from '../../../api/task';
import { ApiContext } from '../../../contexts/ApiContext';
import { getDate } from '../../../utils/transformer';
import { useSnackBar } from '../../Common/SnackBarContext';
import { ReactHookFormComboBox } from '../Form';

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.typography.h1,
  },
  ketentuan: {
    margin: theme.spacing(3, 0),
  },
  img: {
    width: '20%',
    margin: 'auto',
  },
}));

const ChoiceTask = ({ taskResponse }) => {
  const classes = useStyles();

  const { handleSubmit, errors, control } = useForm({
    mode: 'onBlur',
  });
  const snackBarHelper = useSnackBar();
  const apiContext = useContext(ApiContext);
  const [isSendable, setIsSendable] = useState(true);

  const onSubmit = async (data) => {
    snackBarHelper.openSnackBar('info', 'Mengirim...');
    setIsSendable(false);
    try {
      const sub = await reSubmitTask(
        apiContext.axios,
        taskResponse?.id,
        taskResponse?.task?.id,
        data[taskResponse?.task.name]
      );
      if (sub) {
        snackBarHelper.openSnackBar('success', 'Permintaan dikirim');
      }
    } catch (err) {
      snackBarHelper.openSnackBar('error', err.toString());
    }
    setIsSendable(true);
  };

  return (
    <>
      <h2 className={''}>{taskResponse?.task.name}</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ReactHookFormComboBox
          key={taskResponse?.task.name}
          options={taskResponse?.task.widget_parameters.options}
          type={taskResponse?.task.widget_parameters.type}
          attr={taskResponse?.task.name}
          defaultValue={taskResponse?.response}
          rules={taskResponse?.task.widget_parameters.rules}
          control={control}
          error={errors[taskResponse?.task.name]}
          disabled={taskResponse?.status === 'ACCEPTED'}
        />
        <div className={classes.ketentuan}>
          <div className={''}>{taskResponse.task?.description}</div>
          <div>
            Status submisi Anda adalah{' '}
            <strong>{String(taskResponse?.status).toLowerCase()}</strong>
            <div>
              Submisi dilakukan pada {getDate(taskResponse?.last_submitted_at)}{' '}
            </div>
          </div>
        </div>
        <div id="simpan" className="mt-4">
          {taskResponse?.status !== 'ACCEPTED' ? (
            <Button
              variant="contained"
              type="button"
              color="secondary"
              startIcon={<SendIcon />}
              disabled={!isSendable}
              onClick={handleSubmit(onSubmit)}
            >
              {taskResponse?.status === 'CANCELLED' ? 'PERBAIKI' : 'PERBARUI'}
            </Button>
          ) : (
            <h3>Terima Kasih</h3>
          )}
          <Collapse in={!isSendable}>
            <Alert elevation={6} variant="filled" severity="info">
              Harap tetap di laman ini selama formulir Anda dikirim
            </Alert>
          </Collapse>
        </div>
      </form>
    </>
  );
};

export default ChoiceTask;
